import {InfrastructureError, InfrastructureErrorType} from "@app/core/shared/domain/infrastructure.error";
import {ApiError} from "@app/core/shared/domain/api.error";

/**
 * Error thrown when the coupon is already used in another order
 */
export class CouponAlreadyUsedError extends InfrastructureError{
    // The order number where the coupon was used
    orderNumber: string;
    apiError: ApiError;
    constructor(errorMessage: string, orderNumber: string, error: Error, apiError: ApiError) {
        super(InfrastructureErrorType.BackendError, error, errorMessage, apiError)
        this.apiError = apiError;
        this.stack = ""
        this.orderNumber = orderNumber
    }

}
